<template>
	<div>
		<v-app-bar app fixed flat color="transparent" height="88" class="landing-appbar-wrapper">
			<div class="landing-floating-topbar" :class="{ 'is-scrolled': isScrolled }">
				<!-- Right: Logo & Brand Name (in RTL) -->
				<div class="topbar-brand" @click="goToHome()">
					<img :src="require('@/assets/jetaqsaat-logo.png')" alt="جت اقساط" class="topbar-logo" />
					<div class="topbar-brand-text">
						<span class="brand-title">نرم افزار مدیریت اقساط مشتریان</span>
						<span class="brand-tagline">جت اقساط</span>
					</div>
				</div>

				<!-- Center: Desktop Navigation Items -->
				<nav class="topbar-nav hidden-sm-and-down">
					<button type="button" class="nav-link-btn" @click="scrollToSection('features')">
						<v-icon small class="nav-icon ml-1">mdi-view-dashboard-outline</v-icon>
						<span>امکانات</span>
					</button>

					<button type="button" class="nav-link-btn nav-link-highlight" @click="scrollToSection('jet-2min')">
						<span class="pulse-indicator"></span>
						<v-icon small class="nav-icon ml-1">mdi-flash</v-icon>
						<span>جت اقساط در ۲ دقیقه</span>
					</button>

					<button type="button" class="nav-link-btn" @click="scrollToSection('pricing')">
						<v-icon small class="nav-icon ml-1">mdi-tag-outline</v-icon>
						<span>قیمت‌ها</span>
					</button>

					<button type="button" class="nav-link-btn" @click="scrollToSection('consultation')">
						<v-icon small class="nav-icon ml-1">mdi-phone-in-talk-outline</v-icon>
						<span>درخواست مشاوره</span>
					</button>
				</nav>

				<!-- Left: Actions (Login Button & Mobile Toggle) -->
				<div class="topbar-actions">
					<v-btn class="login-btn hidden-xs-only" elevation="0" rounded dark @click="goToLogin">
						<v-icon left small>mdi-login-variant</v-icon>
						<span>ورود به پنل کاربری</span>
					</v-btn>

					<v-btn icon class="hidden-md-and-up mobile-toggle-btn" @click="drawer = !drawer" aria-label="منو">
						<v-icon color="#522ea8">mdi-menu</v-icon>
					</v-btn>
				</div>
			</div>
		</v-app-bar>

		<!-- Mobile Navigation Drawer -->
		<v-navigation-drawer v-model="drawer" fixed temporary right class="landing-mobile-drawer">
			<div class="mobile-drawer-header">
				<div class="d-flex align-center">
					<img :src="require('@/assets/jetaqsaat-logo.png')" alt="جت اقساط" class="drawer-logo" />
					<div class="mr-2">
						<div class="font-weight-black brand-purple-text">{{ longTitle || 'جت اقساط' }}</div>
						<small class="grey--text">مدیریت هوشمند وام و اقساط</small>
					</div>
				</div>
				<v-btn icon small @click="drawer = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>

			<v-divider class="my-3" />

			<v-list nav dense class="mobile-drawer-list">
				<v-list-item link @click="scrollToSection('features')">
					<v-list-item-icon>
						<v-icon color="#522ea8">mdi-view-dashboard-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="font-weight-bold">امکانات</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item link @click="scrollToSection('jet-2min')" class="mobile-highlight-item">
					<v-list-item-icon>
						<v-icon color="#e65100">mdi-flash</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="font-weight-black orange--text text--darken-3">جت اقساط در ۲ دقیقه</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item link @click="scrollToSection('pricing')">
					<v-list-item-icon>
						<v-icon color="#522ea8">mdi-tag-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="font-weight-bold">قیمت‌ها</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item link @click="scrollToSection('consultation')">
					<v-list-item-icon>
						<v-icon color="#522ea8">mdi-phone-in-talk-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="font-weight-bold">درخواست مشاوره</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>

			<div class="mobile-drawer-footer pa-4">
				<v-btn block class="login-btn" rounded dark elevation="0" @click="goToLogin">
					<v-icon left small>mdi-login-variant</v-icon>
					ورود به پنل کاربری
				</v-btn>
			</div>
		</v-navigation-drawer>
	</div>
</template>

<script>
import { get } from 'vuex-pathify'
import router from '@/router'

export default {
	name: 'LandingAppBar',

	data() {
		return {
			drawer: false,
			isScrolled: false
		}
	},

	computed: {
		...get('siteConfig', [
			'longTitle'
		])
	},

	mounted() {
		window.addEventListener('scroll', this.handleScroll, { passive: true })
		this.handleScroll()
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},

	methods: {
		handleScroll() {
			this.isScrolled = window.scrollY > 20
		},

		goToLogin() {
			this.drawer = false
			router.push({ name: 'Login' }).catch(() => { })
		},

		goToHome() {
			this.drawer = false
			router.push({ path: '/' }).catch(() => { })
		},

		scrollToSection(sectionId) {
			this.drawer = false
			const element = document.getElementById(sectionId)
			const navOffset = 95

			if (element) {
				// Element exists on the current page
				const elementPosition = element.getBoundingClientRect().top
				const offsetPosition = elementPosition + window.pageYOffset - navOffset

				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth'
				})

				if (window.history && window.history.pushState) {
					window.history.pushState(null, null, `#${sectionId}`)
				}
			} else {
				// Element does not exist on current page (e.g. user is on another landing page)
				const targetHash = `#${sectionId}`
				if (this.$route.path === '/') {
					// Already on root, wait a moment for DOM rendering if needed
					setTimeout(() => {
						const retryEl = document.getElementById(sectionId)
						if (retryEl) {
							const pos = retryEl.getBoundingClientRect().top + window.pageYOffset - navOffset
							window.scrollTo({ top: pos, behavior: 'smooth' })
						}
					}, 150)
				} else {
					// Navigate to home with hash
					this.$router.push({ path: '/', hash: targetHash }).then(() => {
						this.$nextTick(() => {
							setTimeout(() => {
								const retryEl = document.getElementById(sectionId)
								if (retryEl) {
									const pos = retryEl.getBoundingClientRect().top + window.pageYOffset - navOffset
									window.scrollTo({ top: pos, behavior: 'smooth' })
								}
							}, 300)
						})
					}).catch(() => { })
				}
			}
		}
	}
}
</script>

<style lang="scss">
.landing-appbar-wrapper {
	z-index: 100 !important;
	padding: 0 !important;

	.v-toolbar__content {
		max-width: 1240px;
		margin: 0 auto;
		padding: 0 16px;
		height: 88px !important;
		display: flex;
		align-items: center;
	}
}

.landing-floating-topbar {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 22px;
	border-radius: 50px;
	background: rgba(255, 255, 255, 0.88);
	backdrop-filter: blur(18px);
	-webkit-backdrop-filter: blur(18px);
	border: 1px solid rgba(82, 46, 168, 0.12);
	box-shadow: 0 8px 30px -8px rgba(82, 46, 168, 0.12), 0 2px 8px rgba(0, 0, 0, 0.03);
	transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);

	&.is-scrolled {
		background: rgba(255, 255, 255, 0.97);
		border-color: rgba(82, 46, 168, 0.22);
		box-shadow: 0 12px 36px -8px rgba(82, 46, 168, 0.2), 0 4px 14px rgba(0, 0, 0, 0.05);
		transform: translateY(-2px);
	}
}

.topbar-brand {
	display: flex;
	align-items: center;
	cursor: pointer;
	user-select: none;
	transition: transform 0.2s ease;

	&:hover {
		transform: scale(1.02);
	}

	.topbar-logo {
		height: 42px;
		max-width: 110px;
		object-fit: contain;
		margin-left: 10px;
	}

	.topbar-brand-text {
		display: flex;
		flex-direction: column;

		.brand-title {
			font-family: "Emkan-Bold", "Yekan", sans-serif;
			font-weight: 900;
			font-size: 1.15rem;
			color: #522ea8;
			line-height: 1.2;
			letter-spacing: -0.2px;
		}

		.brand-tagline {
			font-size: 0.68rem;
			color: #7a7195;
			font-weight: 500;
			margin-top: 1px;
		}
	}
}

.topbar-nav {
	display: flex;
	align-items: center;
	gap: 6px;

	.nav-link-btn {
		display: inline-flex;
		align-items: center;
		padding: 8px 14px;
		border-radius: 20px;
		background: transparent;
		border: none;
		outline: none;
		color: #433857;
		font-family: inherit;
		font-size: 0.9rem;
		font-weight: 600;
		cursor: pointer;
		position: relative;
		transition: all 0.25s ease;

		.nav-icon {
			color: #7b6f98;
			transition: color 0.25s ease, transform 0.25s ease;
		}

		&:hover {
			color: #522ea8;
			background: rgba(82, 46, 168, 0.06);

			.nav-icon {
				color: #522ea8;
				transform: translateY(-1px);
			}
		}

		&.nav-link-special {
			color: #e65100;
			background: rgba(255, 152, 0, 0.1);
			border: 1px solid rgba(255, 152, 0, 0.3);
			font-weight: 700;

			&:hover,
			&.is-active {
				background: rgba(255, 152, 0, 0.2);
				border-color: #ff9800;
				color: #e65100;
				transform: translateY(-1px);
			}
		}

		&.nav-link-highlight {
			color: #522ea8;
			background: rgba(82, 46, 168, 0.08);
			border: 1px solid rgba(82, 46, 168, 0.16);

			.nav-icon {
				color: #ff8f00;
			}

			&:hover {
				background: rgba(82, 46, 168, 0.14);
				transform: translateY(-1px);
			}

			.pulse-indicator {
				display: inline-block;
				width: 7px;
				height: 7px;
				border-radius: 50%;
				background-color: #ff9800;
				margin-left: 6px;
				box-shadow: 0 0 0 0 rgba(255, 152, 0, 0.7);
				animation: navPulse 2s infinite;
			}
		}
	}
}

@keyframes navPulse {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 152, 0, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 6px rgba(255, 152, 0, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 152, 0, 0);
	}
}

.topbar-actions {
	display: flex;
	align-items: center;

	.login-btn {
		background: linear-gradient(135deg, #522ea8 0%, #6e41dc 100%) !important;
		color: #ffffff !important;
		font-family: inherit;
		font-weight: 700;
		font-size: 0.88rem;
		padding: 0 20px !important;
		height: 42px !important;
		box-shadow: 0 4px 15px rgba(82, 46, 168, 0.3) !important;
		transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 8px 24px rgba(82, 46, 168, 0.45) !important;
			background: linear-gradient(135deg, #43238e 0%, #5d34c0 100%) !important;
		}
	}

	.mobile-toggle-btn {
		margin-right: 4px;
	}
}

/* Mobile Navigation Drawer */
.landing-mobile-drawer {
	z-index: 1000 !important;

	.mobile-drawer-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 12px 10px;

		.drawer-logo {
			height: 38px;
			object-fit: contain;
		}

		.brand-purple-text {
			color: #522ea8;
			font-size: 1.05rem;
		}
	}

	.mobile-drawer-list {
		.v-list-item {
			border-radius: 12px;
			margin-bottom: 6px;

			&:hover {
				background: rgba(82, 46, 168, 0.06);
			}
		}

		.mobile-highlight-item {
			background: rgba(255, 152, 0, 0.08);
			border: 1px solid rgba(255, 152, 0, 0.25);
		}
	}
}
</style>
